import { service } from '@ember/service';
import { isPresent } from '@ember/utils';
import { Ability } from 'ember-can';
import type AuthzService from 'garaje/services/authz';
import type CurrentAdminService from 'garaje/services/current-admin';
import type StateService from 'garaje/services/state';
import { GLOBAL_ADMIN, LOCATION_ADMIN, RECEPTIONIST } from 'garaje/utils/roles';
import { Permission } from 'garaje/utils/ui-permissions';
import _intersection from 'lodash/intersection';

const CAN_REVIEW_ROLES = [GLOBAL_ADMIN, LOCATION_ADMIN, RECEPTIONIST];

export default class IdScanningAbility extends Ability {
  @service declare authz: AuthzService;
  @service declare currentAdmin: CurrentAdminService;
  @service declare state: StateService;

  get canEnable(): boolean {
    return !!this.state.features?.canAccessIdScanning;
  }

  get canManageConfiguration(): boolean {
    return this.authz.hasPermissionAtCurrentLocation(Permission.VISITORS_ID_SCAN_CONFIGURATION_MANAGE);
  }

  get canReview(): boolean {
    const { roleNames: roles } = this.currentAdmin;
    return isPresent(_intersection(CAN_REVIEW_ROLES, roles));
  }
}
